import { render, staticRenderFns } from "./AlgoliaTypeahead.vue?vue&type=template&id=0f8149f0"
import script from "./AlgoliaTypeahead.vue?vue&type=script&lang=js"
export * from "./AlgoliaTypeahead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports